import { render, staticRenderFns } from "./PlayerHand.vue?vue&type=template&id=c64d04c2&scoped=true&"
import script from "./PlayerHand.vue?vue&type=script&lang=js&"
export * from "./PlayerHand.vue?vue&type=script&lang=js&"
import style0 from "./PlayerHand.vue?vue&type=style&index=0&id=c64d04c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d04c2",
  null
  
)

export default component.exports